module.exports = __webpack_public_path__ + "img/trackiconwithdot.28501e72.svg";